<style scoped>
    .expand-row{
        margin-bottom: 16px;
    }
</style>
<template>
    <div>
         <Table :columns="columnsExpand" :data="row.salesOrders" stripe ref="table" ></Table>
    </div>
</template>
<script>
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AppConsts from '@/lib/appconst';
    export default {
        props: {
            row: Object
        },
         data() {
            var columns =  [
                    {
                        title: Util.L('Code'),
                        key: 'code',
                        width:"200"
                    },
                     {
                        title: Util.L('ExternalCode'),
                        key: 'externalCode',
                        width:"200"
                    },
                     {
                        title: Util.L('CreationTime'),
                        key: 'creationTime',
                         render: (h, params) => {
                            return h("span", Util.toViewDateString(params.row.creationTime));
                        }
                    }
                ]

            return {
                columnsExpand : columns,
            }
        },
    };
</script>
